"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoading = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledLoading = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  justify-content: center;

  &.top {
    flex-direction: column-reverse;
  }

  &.right {
    flex-direction: row;

    span {
      margin-right: 1rem;
    }
  }

  &.bottom {
    flex-direction: column;
  }

  &.left {
    flex-direction: row-reverse;

    span {
      margin-left: 1rem;
    }
  }
`;
exports.default = exports.StyledLoading;
